import {Component, OnInit, Directive, Output, Input, EventEmitter} from '@angular/core';
import {TagsService} from '../tags.service';
import {Tag} from '../tag';

@Component({
    selector: 'tags-handler',
    providers: [TagsService],
    template: require('./tags-handler.component.html'),
})
export class TagsHandlerComponent implements OnInit{    

    allTags: Tag[];    
    toShowTags: Tag[];
    selectedTags: Tag[];
    tagsToShow: number;
    page: number;
    @Input('loadedTagsIds') tagsIds: Number[];
    @Output() emiter = new EventEmitter();
    tagsSearcher: string;

    constructor(private _tagsService: TagsService) {
        this.allTags = [];       
        this.toShowTags = [];
        this.selectedTags = []; 
        this.tagsToShow = 12; 
        this.page = 0;
        this.tagsSearcher = "";               
    }
    
    ngOnInit() {        
        this._tagsService.getTagsOrderedByName().then(result => {
            this.allTags = result;            
            for(var i = 0; i < this.allTags.length; i++) {      
                this.allTags[i].selected = false;                
                for(var j = 0; j < this.tagsIds.length; j++) {
                    if(this.allTags[i].id == this.tagsIds[j]) {
                        if(!this.allTags[i].selected) {
                            this.allTags[i].selected = true;
                            this.selectedTags.push(this.allTags[i]);
                        }
                    }
                }                          
            }

            this.toShowTags = this.allTags;

            // if(this.selectedTags.length > 0) {
            //     this.emiter.emit({
            //         value: this.selectedTags
            //     })
            // }
        });
    }

    tagClicked(tag: Tag) {
        if(!tag.selected) {
            tag.selected = true;
            this.selectedTags.push(tag);
        } else {
            tag.selected = false;
            var index = this.selectedTags.indexOf(tag);
            this.selectedTags.splice(index, 1);
        }        
    }

    removeTags() {
        for(var i = 0; i < this.toShowTags.length; i++) {
            this.toShowTags[i].selected = false;
        }

        this.selectedTags = [];
        this.applyFiltersClicked();
    }

    applyFiltersClicked() {
        this.tagsSearcher = "";
        this.toShowTags = this.allTags;
        this.page = 0;
        this.emiter.emit({
            value: this.selectedTags
        })
    }

    getTagColor(tag: Tag) {
        if(tag.selected) {
            return "#97D685";
        } else {
            return "#6fb3cb";
        }
    }

    isSelected(tag: Tag) {
        return tag.selected;
    }


    previousTagsClicked() {
        this.page--;
    }

    nextTagsClicked() {        
        this.page++;        
    }

    tagsSearcherChanged() {        
        this.page = 0;
        if(this.tagsSearcher != null && this.tagsSearcher != undefined && this.tagsSearcher != "") {

            this.toShowTags = [];
            for(var i = 0; i < this.allTags.length; i++) {
                var tagName = this.toUpperCaseReplacingAccents(this.allTags[i].name);
                var tagsSearcherFilter = this.toUpperCaseReplacingAccents(this.tagsSearcher);

                if(tagName.indexOf(tagsSearcherFilter) !== -1) {
                    this.toShowTags.push(this.allTags[i]);
                }
            }
            // this.modalTags = [];
            // for(var i = 0; i < this.tagsHaveNot.length; i++) {
                
            //     var tagName = this.toUpperCaseReplacingAccents(this.tagsHaveNot[i].name);                                                                    
            //     var filterText = this.toUpperCaseReplacingAccents(this.tagsModalFilter);                              

            //     if(tagName.indexOf(filterText) !== -1) {

            //         this.modalTags.push(this.tagsHaveNot[i]);

            //     }

            // }

        } else {

            this.toShowTags = this.allTags;
            // this.modalTags = this.tagsHaveNot;

        }

    }

    toUpperCaseReplacingAccents(text: string): string {

        var mapObj = {
            Á: "A",
            À: "A",
            Ä: "A",
            É: "E",
            È: "E",
            Ë: "E",
            Í: "I",
            Ì: "I",
            Ï: "I",
            Ó: "O",
            Ò: "O",
            Ö: "O",
            Ú: "U",
            Ù: "U",
            Ü: "U"            
        };

        var trim = text.toUpperCase();
        trim = trim.replace(/Á|À|Ä|É|È|Ë|Í|Ì|Ï|Ó|Ò|Ö|Ú|Ù|Ü/g, function(char){
            return mapObj[char];
        });

        return trim;

    }

}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/main/tags_handler/tags-handler.component.ts
 **/